import { Keyboard } from "@capacitor/keyboard";
import { isCapacitorPlatform } from "@src/appV2/lib";
import { KeyboardEvent } from "react";

export function hideKeyboardOnKeyPressEnter(e: KeyboardEvent<HTMLIonInputElement>) {
  if (isCapacitorPlatform() && e.key === "Enter") {
    Keyboard.hide();
  }
}
